/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import {
  AccountingAccountDto,
  AccountingAccountFilterDto,
  SystemVarsAccountingExpenseDto,
  SystemVarsAccountingJobsDto,
  SystemVarsAccountingReceivableDto,
} from '@gh/builder-shared-data';
import { createArrayHelper } from '@gh/common-shared';
import { composeComparators, valueComparator } from '@gh/core-util';

export type SystemVarsAccountingReceivableModel = SystemVarsAccountingReceivableDto;
export type SystemVarsAccountingJobsModel = SystemVarsAccountingJobsDto;
export type SystemVarsAccountingExpenseModel = SystemVarsAccountingExpenseDto;
export type AccountingAccount = AccountingAccountDto & { groupTitle?: boolean };
export type AccountingAccountFilter = AccountingAccountFilterDto;

export const getAccountingAccountId = (item: AccountingAccountDto) => item.externalId || '';
export const accountingAccountArr = createArrayHelper(getAccountingAccountId);

export const accountCodeComparator = valueComparator<AccountingAccount>(({ code }) => Number(code));
export const accountNameComparator = valueComparator<AccountingAccount>('name');
export const accountComparator = composeComparators(accountCodeComparator, accountNameComparator);
